import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { avatarSmallWidth, avatarMediumWidth, avatarLargeWidth } from './variables';
var colors = tokens.colors;
var _ref = {
  name: "uodor8",
  styles: "border-radius:50%;"
};
var _ref2 = {
  name: "b7rhyr",
  styles: "border:1px solid;"
};
export var avatarDetails = (shape, size, colorScheme, isBordered) => /*#__PURE__*/css("overflow:hidden;position:relative;text-align:left;", shape === 'circle' && _ref, " ", size === 'small' && /*#__PURE__*/css("width:", avatarSmallWidth, ";height:", avatarSmallWidth, ";"), " ", size === 'medium' && /*#__PURE__*/css("width:", avatarMediumWidth, ";height:", avatarMediumWidth, ";"), " ", size === 'large' && /*#__PURE__*/css("width:", avatarLargeWidth, ";height:", avatarLargeWidth, ";"), " ", colorScheme === 'dark' && /*#__PURE__*/css("border-color:", colors.neutral.medium.default, ";background-color:", colors.neutral.trim.default, ";color:", colors.neutral.medium.default, ";"), " ", colorScheme === 'light' && /*#__PURE__*/css("border-color:", colors.neutral.base.default, ";background-color:", colors.neutral.subdued.default, ";color:", colors.neutral.base.default, ";"), " ", isBordered && _ref2);
export var avatarImage = {
  name: "6jrdpz",
  styles: "width:100%;height:100%;object-fit:cover;"
};